import React from 'react';
import { Link } from 'react-router-dom';
import '../Explore.css'

export default function Landing() {
    const baseUrl = `${process.env.REACT_APP_API_URL}uploads/MGT72023-2024/`;
    return (
        <>
            <section className="section section--masthead basic">
                <div className="container">
                    <div className="breadcrumbs">
                        <ol itemScope="" itemType="https://schema.org/BreadcrumbList">
                            <li className="crumb" itemProp="itemListElement" itemScope="" itemType="https://schema.org/ListItem">
                                <a itemProp="item" href={`${process.env.REACT_APP_APP_URL}`}>
                                    <span itemProp="name">Home</span>
                                </a>
                                <meta itemProp="position" content="1" />
                            </li>
                            <li className="crumb" itemProp="itemListElement" itemScope="" itemType="https://schema.org/ListItem">
                                                           <Link to={`/legal-documents`}>
                                                                <span itemProp="name">Legal Documents</span>
                                                            </Link>
                                                            <meta itemProp="position" content="1" />
                                                        </li>
                            <li className="crumb crumb-3" itemProp="itemListElement" itemScope="" itemType="https://schema.org/ListItem">
                                <span itemProp="item">
                                    <span itemProp="name">
                                        <strong>Middleby Celfrost Form MGT7 2022 23</strong>
                                    </span>
                                </span>
                                <meta itemProp="position" content="2" />
                            </li>
                        </ol>
                    </div>
                </div>
            </section>
            <section className="section section--contact">
                <div className="container">
                    <div className="row g-4 mb-5">
                        <div className="col-lg-10">
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0001.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0001" title="Form_MGT_7-MCIPL-2023-24_pages-0001" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0002.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0002" title="Form_MGT_7-MCIPL-2023-24_pages-0002" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0003.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0003" title="Form_MGT_7-MCIPL-2023-24_pages-0003" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0004.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0004" title="Form_MGT_7-MCIPL-2023-24_pages-0004" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0005.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0005" title="Form_MGT_7-MCIPL-2023-24_pages-0005" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0006.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0006" title="Form_MGT_7-MCIPL-2023-24_pages-0006" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0007.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0007" title="Form_MGT_7-MCIPL-2023-24_pages-0007" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0008.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0008" title="Form_MGT_7-MCIPL-2023-24_pages-0008" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0009.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0009" title="Form_MGT_7-MCIPL-2023-24_pages-0009" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0010.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0010" title="Form_MGT_7-MCIPL-2023-24_pages-0010" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0011.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0011" title="Form_MGT_7-MCIPL-2023-24_pages-0011" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0012.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0012" title="Form_MGT_7-MCIPL-2023-24_pages-0012" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0013.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0013" title="Form_MGT_7-MCIPL-2023-24_pages-0013" />
      <img src={`${baseUrl}Form_MGT_7-MCIPL-2023-24_pages-0014.jpg`} alt="Form_MGT_7-MCIPL-2023-24_pages-0014" title="Form_MGT_7-MCIPL-2023-24_pages-0014" />
                        </div>

                    </div>
                </div>
            </section>

        </>
    )
}